import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Tr.css';

const Tr = ({ children, className, ...rest }) => (
  <tr className={classNames('tr', className)} {...rest} >
    { children }
  </tr>
);

Tr.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Tr;



// WEBPACK FOOTER //
// ./src/components/Tr/Tr.jsx